import React, { useState, useRef } from 'react';
import { Container } from 'react-bootstrap';
import ApplicationsList from './ApplicationsList';
import ApplicationView from './ApplicationView';
import './Email.css';

const Applications = () => {
  const [selectedApplicationId, setSelectedApplicationId] = useState(null);
  const [showApplicationView, setShowApplicationView] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const applicationsListRef = useRef(null);

  const handleViewApplication = (applicationId) => {
    setSelectedApplicationId(applicationId);
    setShowApplicationView(true);
  };

  const handleApplicationStatusChange = () => {
    // Force refresh by updating key
    setRefreshKey(prev => prev + 1);
  };

  return (
    <Container fluid className="email-page">
      {/* Header */}
      <div className="email-header">
        <div className="mb-4">
          <h2 className="email-page-title">Employment Applications</h2>
          <p className="text-muted mb-0">View and manage employment applications</p>
        </div>
      </div>

      {/* Applications List */}
      <ApplicationsList
        key={refreshKey}
        ref={applicationsListRef}
        onViewApplication={handleViewApplication}
        onStatusChange={handleApplicationStatusChange}
      />

      {/* Application View Modal */}
      <ApplicationView
        show={showApplicationView}
        onHide={() => {
          setShowApplicationView(false);
          setSelectedApplicationId(null);
        }}
        applicationId={selectedApplicationId}
        onStatusChange={handleApplicationStatusChange}
      />
    </Container>
  );
};

export default Applications;

